module.exports = __webpack_public_path__ + "media/images/design/images/h2_report-1787be92a6a5703b192feddb1eeadfaf.png";